import { render, staticRenderFns } from "./QuestionnaireFormTableQuestion.vue?vue&type=template&id=af435612&"
import script from "./QuestionnaireFormTableQuestion.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireFormTableQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireFormTableQuestion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports